import { Button } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { FullScreenHandle } from 'react-full-screen';

export default function CloseFullScreen({ fullScreenHandle }: { fullScreenHandle: FullScreenHandle }) {
    return (
        <Button
            sx={{ position: 'absolute', right: '16px', top: '16px', zIndex: 1 }}
            variant="light"
            onClick={fullScreenHandle.exit}
            className={'min-width--icon'}
        >
            <IconMi icon="times" />
        </Button>
    );
}
